(function (Drupal, $, once) {
  Drupal.behaviors.film_guidance_overlay = {
    attach: function attach(context) {
      const film_guidance_overlay = once(
        'film_guidance_overlay',
        '[data-component-id="nuplayer:film_guidance_overlay"]',
        context
      );
      if (film_guidance_overlay.length > 0) {
        const film_page_header = '[data-component-id="nuplayer:film_page_header"]';
        const film_page_media_player = '[data-component-id="nuplayer:film_page_media_player"]';
        $.displayOverlay = function (overlay) {
          $('.player-overlay--' + overlay).removeClass('d-n');

          // accessibility
          let modal = document.querySelector('.player-overlay--' + overlay);
          modal.setAttribute('tabindex', '0');
          modal.focus();

          $(film_page_header).trigger('film_page_header:scroll_into_view');
        };

        // Show the certification and/or viewing notice
        $(film_guidance_overlay).on('film_guidance_overlay:show', function (_event) {
          if (
            $('.player-overlay--certification').hasClass('player-overlay--certification--accepted')
          ) {
            $(film_page_media_player).trigger('film_page_media_player:play_film');
            $(film_page_header).trigger('film_page_header:scroll_into_view');
          } else if ($('.player-enabled').length > 0) {
            $.displayOverlay('certification');
          }
        });

        // Certification overlay specific close
        $('.js__close').on('click', function (event) {
          event.preventDefault();
          if ($('.player-overlay--viewing-notice').is(':visible')) {
            $(this)
              .closest('.player-overlay--viewing-notice')
              .addClass('player-overlay--viewing-notice--accepted')
              .addClass('d-n');
            if (
              $('.player-overlay--certification').length > 0 &&
              !$('.player-overlay--certification').hasClass(
                'player-overlay--certification--accepted'
              )
            ) {
              $.displayOverlay('certification');
            }
          } else {
            $(this)
              .closest('.player-overlay--certification')
              .addClass('player-overlay--certification--accepted')
              .addClass('d-n');
            $(film_page_media_player).trigger('film_page_media_player:play_film');
            $(film_page_header).trigger('film_page_header:scroll_into_view');
          }
        });

        // If dismissing we just reset the page to the header
        $('.js__dismiss-overlay').on('click', function () {
          $(this).closest('.player-overlay').addClass('d-n');
          $(film_page_header).removeClass('film-header--playing');
        });
      }
    },
  };
})(Drupal, jQuery, once);
